// Calculator modes. 'basic' is the classic calculator (its id predates the
// name and is kept so saved preferences and share links still work).
export const MODES = {basic: 'basic', matchup: 'matchup'};
